export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更完成公告_en-0d9682b380e845248579f88561564dcb.webp";